
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"71","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"29.5","cy":"33.5","rx":"29.5","ry":"37.5","fill":"url(#paint0_linear_6533_7892)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_6533_7892","x1":"3.952","y1":"52.25","x2":"60.429","y2":"26.599","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#3D73EB"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#DE8FFF"}})])])])
          )
        }
      }
    